import api from "../api";

// Dashboard istatistikleri
export const getDashboardStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "admin/analytics/dashboard");
};

// Gelir analitiği
export const getRevenueAnalytics = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/analytics/revenue", { params });
};

// Kullanıcı büyüme analitiği
export const getUserGrowthAnalytics = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/analytics/user-growth", { params });
};

